import appStaticMessagesData from '../../../assets/i18n/en.json';
import * as i0 from "@angular/core";
export class AppMessagesService {
    constructor() {
        this.appStaticMessages = appStaticMessagesData;
    }
    customRequiredMessages(fieldName) {
        return this.appStaticMessages.AppMessageService.customRequiredMessages + fieldName + '.';
    }
    personalRequiredMessages(fieldName) {
        return this.appStaticMessages.AppMessageService.personalRequiredMessages + fieldName + '.';
    }
    customSelector(fieldName) {
        return this.appStaticMessages.AppMessageService.customSelector + fieldName + '.';
    }
    customValidator(fieldName) {
        return this.appStaticMessages.AppMessageService.customValidator + fieldName + '.';
    }
    minLengthRequired(fieldName, minLength) {
        return this.appStaticMessages.AppMessageService.minimum + fieldName
            + this.appStaticMessages.AppMessageService.lenghtShouldBe + minLength + '.';
    }
    maxLengthRequired(fieldName, maxLength) {
        return this.appStaticMessages.AppMessageService.maximum + fieldName
            + this.appStaticMessages.AppMessageService.lenghtShouldBe + maxLength + '.';
    }
}
AppMessagesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppMessagesService_Factory() { return new AppMessagesService(); }, token: AppMessagesService, providedIn: "root" });
//# sourceMappingURL=app-messages.service.js.map